import PropTypes from 'prop-types'
import React from 'react'
import { NavItem, NavLink } from 'reactstrap'

const NavItems = ({ navs, startNav, setCurrentNav, withIcon = false }) =>
  navs.map(nav => (
    <NavItem key={nav.name}>
      <NavLink
        data-toggle="tab"
        href="#pablo"
        role="tab"
        className={startNav === `${nav.name}` ? 'active' : ''}
        onClick={() => setCurrentNav(`${nav.name}`)}
      >
        {withIcon ? (
          <span>
            <i className={nav.icon} /> {nav.name}
          </span>
        ) : (
          <span className="text-info">{nav.name}</span>
        )}
      </NavLink>
    </NavItem>
  ))

NavItems.propTypes = {
  navs: PropTypes.array,
  startNav: PropTypes.string,
  setCurrentNav: PropTypes.func,
}

export default NavItems
